export default __webpack_public_path__ + "static/media/slider_image_01-md@1x.0f446373.jpg";